import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IStatistic } from '@grassrootly/api/entities/IStatistic';

export interface StatsState {
  monthly: { [key: string]: IStatistic };
}

const initialState: StatsState = {
  monthly: {},
};

const statsSlice = initReducer({
  name: "stats",
  initialState,
  reducers: {
    setMonthlyStats: (state: StatsState, action: PayloadAction<IStatistic>) => {
      const mappedStat: any = {};
      mappedStat[`${action.payload.month}/${action.payload.year}`] = action.payload;
      state.monthly = { ...state.monthly, mappedStat };
    },
    cleanState: () => {
      return initialState;
    }
  },
});

const persistConfig: PersistConfig<StatsState> = {
  key: "stats",
  storage: AsyncStorage,
};

export const statsActions = statsSlice.actions;

export default createPersistReducer(persistConfig, statsSlice.reducer);
